import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-manufacturing-overview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manufacturing-overview.html',
  styleUrls: ['./manufacturing-overview.css'],
})
export class ManufacturingOverviewComponent {}
